import React, { useState } from "react";
import Header from './layouts/header';
import Footer from './layouts/footer';
import LandingLayout from './components/landing/LandingLayout';
import LegalMinimalLayout from './components/landing/LegalMinimalLayout';

const Layout = ({ children, landing, landingChrome, legalMinimal }) => {
    const [showModal, setShowModal] = useState(false);
    const [modalContent, setModalContent] = useState({ title: "", body: "" });
  
    const openModal = (title, body) => {
      setModalContent({ title, body });
      setShowModal(true);
    };
    const setCloseShowModal = () => {
        setShowModal(false);
    }

    const clonedChildren = React.Children.map(children, (child) =>
      React.isValidElement(child)
        ? React.cloneElement(child, { showModal, setCloseShowModal, modalContent })
        : child
    );

    if (legalMinimal) {
      return <LegalMinimalLayout>{clonedChildren}</LegalMinimalLayout>;
    }

    if (landingChrome) {
      return (
        <LandingLayout showModal={showModal} setCloseShowModal={setCloseShowModal}>
          {clonedChildren}
        </LandingLayout>
      );
    }

    return (
        <>
            {!landing && <Header openModal={openModal} />}
            {clonedChildren}
            {!landing && <Footer />}
        </>
    )
}
export default Layout;